export const ZOHO_CLIENT_ID = process.env.REACT_APP_ZOHO_CLIENT_ID;
export const ZOHO_SCOPE = process.env.REACT_APP_ZOHO_SCOPE;
export const ZOHO_REDIRECT_URI = process.env.REACT_APP_ZOHO_REDIRECT_URI;
export const ZOHO_ACCESS_TYPE = process.env.REACT_APP_ZOHO_ACCESS_TYPE;
export const ZOHO_PROMPT = process.env.REACT_APP_ZOHO_PROMPT;

export const WEBSOCKET_CONFIG = {
  SERVER_URL: process.env.REACT_APP_WCA_WEBSOCKET_URL,
  PATH: "/wca-socket",
  TRANSPORTS: ["websocket"],
};
